// Passos do tutorial. A coreografia visual de cada passo vive em
// ./scenes/<id>.js; aqui ficam rota, áudio, título e texto da barra.
const steps = [
	{
		id: "menu",
		path: "/tickets",
		menu: null,
		title: "Bem-vindo ao Flytec! 👋",
		text: "Este menu à esquerda é o seu ponto de partida: por ele você acessa atendimentos, contatos, conexões e muito mais.",
		audio: "/tutorial/step-01.mp3",
	},
	{
		id: "dashboard",
		path: "/",
		menu: "[data-tour='menu-dashboard']",
		title: "Dashboard 📊",
		text: "Acompanhe em tempo real quantos clientes estão em atendimento, quantos aguardam e o desempenho do seu time.",
		audio: "/tutorial/step-02.mp3",
	},
	{
		id: "board",
		path: "/",
		menu: "[data-tour='menu-dashboard']",
		title: "Quadro da equipe 🔀",
		text: "Precisa redistribuir? Arraste o atendimento e solte na coluna de quem vai atender — troca de responsável na hora.",
		audio: "/tutorial/board.mp3",
	},
	{
		id: "connections",
		path: "/connections",
		menu: "[data-tour='menu-connections']",
		title: "Conecte seu WhatsApp 📱",
		text: "Clique em Adicionar WhatsApp, escaneie o código QR com o celular e pronto — as mensagens começam a chegar.",
		audio: "/tutorial/step-03.mp3",
	},
	{
		id: "tickets",
		path: "/tickets",
		menu: "[data-tour='menu-tickets']",
		title: "Atendimentos 💬",
		text: "Cada conversa vira um ticket. Em Aguardando ficam os clientes novos — clique em Aceitar para assumir.",
		audio: "/tutorial/step-04.mp3",
	},
	{
		id: "chat",
		path: "/tickets",
		menu: "[data-tour='menu-tickets']",
		title: "A conversa 🗨️",
		text: "Texto, áudio, foto e emoji em tempo real, como no WhatsApp. Ao terminar, clique em Resolver.",
		audio: "/tutorial/step-05.mp3",
	},
	{
		id: "contacts",
		path: "/contacts",
		menu: "[data-tour='menu-contacts']",
		title: "Contatos 👥",
		text: "Sua agenda completa. Quem te chama entra sozinho — e você pode cadastrar, importar e iniciar conversas daqui.",
		audio: "/tutorial/step-06.mp3",
	},
	{
		id: "quickAnswers",
		path: "/quickAnswers",
		menu: "[data-tour='menu-quickanswers']",
		title: "Respostas Rápidas ⚡",
		text: "Crie atalhos para as perguntas de todo dia. Na conversa, digite / e a mensagem aparece pronta.",
		audio: "/tutorial/step-07.mp3",
	},
	{
		id: "queues",
		path: "/queues",
		menu: "[data-tour='menu-queues']",
		title: "Filas 🗂️",
		text: "Organize por setores — Vendas, Suporte, Financeiro. Cada conexão direciona os clientes para as filas certas.",
		audio: "/tutorial/step-08.mp3",
		adminOnly: true,
	},
	{
		id: "users",
		path: "/users",
		menu: "[data-tour='menu-users']",
		title: "Usuários 🧑‍💼",
		text: "Monte seu time: cadastre atendentes, escolha o perfil e vincule às filas.",
		audio: "/tutorial/step-09.mp3",
		adminOnly: true,
	},
	{
		id: "settings",
		path: "/settings",
		menu: "[data-tour='menu-settings']",
		title: "Configurações ⚙️ — e fim!",
		text: "Ajuste o comportamento da plataforma. Prontinho: você já conhece o Flytec!",
		audio: "/tutorial/step-10.mp3",
		adminOnly: true,
	},
];

export default steps;
